import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { auth, db } from "../../config/firebase";
import { validateUser } from "../utils/UserUtils";

interface Props {
  children: React.ReactNode;
  requiresAdmin?: boolean
}

const AuthChecker = ({ children, requiresAdmin }: Props) => {
  const [loaded, setLoaded] = useState<boolean>(false);

  const navigate = useNavigate();
  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(async function (user) {
      if (user) {
        const docUser = await validateUser(db, user.uid)
        if(requiresAdmin === undefined || !requiresAdmin || (requiresAdmin && docUser?.isAdmin)){
          setLoaded(true)
        } else {
          navigate("/");
        }
      } else {
        navigate("/login");
      }
    });
    return () => {
      unsubscribe();
    };
  }, [])

  return <>{loaded && children}</>;
};

export default AuthChecker;
